import {useEffect, useState} from "react";
import {Grid} from "@mui/system";
import {Typography} from "@mui/material";
import {theme} from "../../../../../Tema";
import {useResponsive} from "../../../../../Modulo_responsive/Hooks/useResponsive";


export const useSeleccion = ({lista}) => {
    const {sCell} = useResponsive()
    const [seleccionado, setSeleccionado] = useState(lista[0])


    useEffect(() => {

        setSeleccionado(lista[0])
    }, [lista])
    const Lista = () => {
        return (
            <Grid
                container
                justifyContent={sCell ? 'center' : 'flex-end'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                {lista.map((it, index) => {
                    return (
                        <Typography
                            onClick={() => setSeleccionado(it)}
                            sx={{
                                transition: 'all .2s ease-in-out',
                                cursor: 'pointer',
                                color: seleccionado === it ? '#fff' : '#000',
                                backgroundColor: seleccionado === it ? theme.palette.primary.main : '#ffffff00',
                                borderRadius: 6,
                                px: 3,
                                py: 0.5,
                                "&:hover": {
                                    backgroundColor: seleccionado === it ? theme.palette.primary.main : theme.palette.primary.main + 20,
                                }
                            }}>
                            {it}
                        </Typography>
                    )
                })}


            </Grid>
        )
    }

    return {
        Lista,
        seleccionado
    }

}